import styles from './Actions.module.scss';
import sharedStyles from '@/modules/opinions/Shared.module.scss';

import { Loader } from '@/components';
import { useHapticFeedback } from '@/hooks/useHapticFeedback';
import { useNavigation } from '@/hooks/useNavigation';
import { useOpinionContext } from '@/modules/opinions';
import { useStore } from '@/store';
import { shareOpinionLink } from '@/utils';
import cn from 'classnames';
import { t } from 'i18next';

import Comment from './images/comment.svg?react';
import Share from './images/share.svg?react';
import { useSwiper } from 'swiper/react';

export const Actions = ({
  isShown,
  onClick,
  disabled,
}: {
  isShown: boolean;
  onClick: () => void;
  disabled: boolean;
}) => {
  const { triggerHapticFeedback } = useHapticFeedback();
  const {
    accountStore: {
      accountData: { invite_code },
    },
  } = useStore();

  const { goBack } = useNavigation();
  const { opinion, isVoted, slidesCount } = useOpinionContext();

  const swiper = useSwiper();

  const onShareClick = () => {
    triggerHapticFeedback('medium');
    shareOpinionLink(opinion._id, invite_code);
  };

  const onNextClick = () => {
    if (swiper.activeIndex + 1 === slidesCount) {
      goBack();
    } else {
      swiper.slideNext();
    }
  };

  const handleTelegramClick = () => {
    window.open('https://t.me/pollocoop', '_blank');
  };

  return (
    <div className={cn(styles.actions, isShown ? sharedStyles.opacity1 : '')}>
      <button className={styles.share} onClick={onShareClick}>
        <Share />
      </button>
      <button className={styles.comment} onClick={handleTelegramClick}>
        <Comment />
      </button>
      {!isVoted ? (
        <button className={styles.next} onClick={onClick} disabled={disabled}>
          {disabled ? <Loader inButton /> : t('Approve')}
        </button>
      ) : (
        <button className={styles.next} onClick={onNextClick}>
          {t('Next')}
        </button>
      )}
    </div>
  );
};
